export const CHECKLIST_KEY_CONFIRM_POC = 'confirm-poc';
export const CHECKLIST_KEY_UPLOAD_LEASE = 'upload-lease';
export const CHECKLIST_KEY_ADD_BUILDING_CONTACTS = 'add-building-contacts';
export const CHECKLIST_KEY_CONFIRM_BILLING_CONTACTS = 'confirm-billing-contacts';
export const CHECKLIST_KEY_ADD_VENDOR_ACCESS_INSTRUCTIONS = 'add-vendor-access-instructions';
export const CHECKLIST_KEY_UPLOAD_COI = 'upload-coi';
export const CHECKLIST_KEY_UPLOAD_FLOORPLAN = 'upload-floorplan';
export const CHECKLIST_KEY_UPLOAD_INSURANCE_REQUIREMENTS = 'upload-insurance-requirements';
export const CHECKLIST_KEY_START_OFFICE_MANUAL = 'start-office-manual';
export const CHECKLIST_KEY_PICK_INTERNET_PLAN = 'pick-internet-plan';
export const CHECKLIST_KEY_SHARE_ISP_NETWORK_DETAILS = 'share-isp-network-details';
export const CHECKLIST_KEY_SELECT_IT_SERVICES = 'select-it-services';
export const CHECKLIST_KEY_SETUP_CLEANING = 'setup-cleaning';
export const CHECKLIST_KEY_SETUP_PANTRY = 'setup-pantry';
